import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

const buildFormData = (payload, attachments) => {
    const formData = new FormData();
    Object.keys(payload || {}).forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null) {
            formData.append(key, payload[key]);
        }
    });
    if (attachments && attachments.length) {
        attachments.forEach(file => {
            formData.append("file[]", file);
        });
    }
    return formData;
};

export const _LeaveRequests = {
    save: (payload, attachments = []) => {
        const payloadWithToken = {
            ...(payload || {}),
            token: AuthAPI.currentUser.accessToken
        };

        if (attachments && attachments.length) {
            const formData = buildFormData(payloadWithToken, attachments);

            return new Promise((resolve, reject) => {
                fetch(APIConfig.url("/modulo-hr/leave-requests/save"), {
                    method: "POST",
                    body: formData
                })
                    .then(response => response.json())
                    .then(json => {
                        json.status === FuxHTTP.STATUS_SUCCESS ? resolve(json.data) : reject(json.message);
                    })
                    .catch(() => reject(null));
            });
        }

        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/leave-requests/save"),
            payloadWithToken,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    pagination: (id_dipendente, page = 1) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/leave-requests/pagination"),
            {
                'id_dipendente[]': id_dipendente,
                page: page,
                token: AuthAPI.currentUser.accessToken
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    getHoursBalance: (id_dipendente, year) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/leave-requests/get-hours-balance"),
            {
                id_dipendente: id_dipendente,
                year: year,
                token: AuthAPI.currentUser.accessToken
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    checkLockedPeriod: (id_dipendente, start_date, end_date) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/leave-requests/check-locked-period"),
            {
                id_dipendente: id_dipendente,
                start_date: start_date,
                end_date: end_date,
                token: AuthAPI.currentUser.accessToken
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_RESPONSE
        );
    },
    delete: (id_dipendente,request_id) => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/leave-requests/delete"),
            {
                id_dipendente: id_dipendente,
                request_id: request_id,
                token: AuthAPI.currentUser.accessToken
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    }
};
